// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Vy28","legacyBtn":"MutateMid_legacyBtn__gMlns"};